// src/utils/commonFunctions.js

/**
 * Convert an ISO date/time string (e.g. "1975-10-01T00:00:00.000Z")
 * to a value accepted by <input type="date"> ("YYYY-MM-DD").
 */
export function formatForDateInput(iso) {
  if (!iso) return "";
  if (typeof iso !== "string") return "";
  // Handles ISO strings and strings that already are YYYY-MM-DD
  if (iso.includes("T")) return iso.split("T")[0];
  return iso;
}

/**
 * Convert a "YYYY-MM-DD" string from <input type="date"> back to an ISO string.
 * NOTE: new Date("YYYY-MM-DD") creates a date at midnight UTC which may shift
 * depending on user's timezone. If you need to preserve "local midnight" behavior,
 * use formatToIsoLocal().
 */
export function formatToIso(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const d = new Date(yyyyMmDd);
  return d.toISOString(); // returns e.g. "1975-10-01T00:00:00.000Z"
}

/**
 * If you want to preserve local-midnight for the given date string (no timezone shift)
 * use this variant. It constructs an ISO-like string using local date parts.
 */
export function formatToIsoLocal(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const [y, m, d] = yyyyMmDd.split("-").map(Number);
  // Create Date using local time at midnight
  const dt = new Date(y, m - 1, d, 0, 0, 0, 0);
  // Convert to ISO — this will include the offset, but the date value represents local midnight.
  return dt.toISOString();
}

